/**
 * FileUploadConstants
 *
 * Shared constants for file upload size limits and allowed MIME types.
 * Used by FileUpload (SharedComponents) and Dropzone.
 */

/** Default maximum file upload size in megabytes. Used as fallback when the
 *  CPM_MAX_FILE_UPLOAD_SIZE feature flag is unavailable or returns 0. */
export const DEFAULT_MAX_FILE_SIZE_MB = 400;

/** Warning threshold in megabytes. Files above this size trigger a Snackbar
 *  advisory, but are not rejected (unless they also exceed DEFAULT_MAX_FILE_SIZE_MB). */
export const LARGE_FILE_WARNING_MB = 200;

/** Allowed MIME types for file uploads.
 *  NOTE: application/zip and application/x-zip-compressed are intentionally excluded. */
export const ALLOWED_MIME_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/vnd.ms-outlook",
  "text/csv",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/msword",
  "application/octet-stream",
];

/** Human-readable labels for the info-icon tooltip listing supported file types. */
export const ALLOWED_FILE_TYPES_DISPLAY = [
  "PDF",
  "JPEG / JPG / PNG",
  "Outlook Message (.msg)",
  "CSV",
  "Excel (.xls, .xlsx)",
  "Word (.doc, .docx)",
];
